module.exports = __webpack_public_path__ + "static/social-737d5c338cf1a036ed32919b38d85019.jpg";